import React from 'react'
import PropTypes from 'prop-types'

function Device({ styling }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      className={styling}
    >
      <switch>
        <g>
          <circle cx={64} cy={78.6} r={1.8} />
          <circle cx={40} cy={82.7} r={1.7} />
          <path d="M95.2 62.5h-3V16.7c0-2.6-2.1-4.7-4.7-4.7h-75c-2.6 0-4.7 2.1-4.7 4.7v45.7h-3c-2.2 0-3.9 1.8-3.9 3.9v2.3c0 2.2 1.8 3.9 3.9 3.9h22.4v10.9c0 2.5 2 4.5 4.5 4.5h16.7c2.3 0 4.1-1.7 4.4-3.8h28.5c2.3 0 4.2-1.9 4.2-4.2v-7.3h9.8c2.2 0 3.9-1.8 3.9-3.9v-2.3c0-2.2-1.8-3.9-4-3.9zM10.8 16.7c0-.9.8-1.7 1.7-1.7h75.1c.9 0 1.7.8 1.7 1.7v1.9H10.8v-1.9zm16.4 52.9H4.8c-.5 0-.9-.4-.9-.9v-2.3c0-.5.4-.9.9-.9h22.4v4.1zm22.6 13.9c0 .8-.7 1.5-1.5 1.5H31.6c-.8 0-1.5-.7-1.5-1.5v-2.9h19.7v2.9zm0-5.9H30.2V55.7h19.7v21.9zm0-24.9H30.2v-.6c0-.8.7-1.5 1.5-1.5h16.7c.8 0 1.5.7 1.5 1.5v.6zm32.7 27.2c0 .7-.6 1.2-1.2 1.2H52.8V76h29.6v3.9zm0-6.9H52.8V52.2c0-2.5-2-4.5-4.5-4.5h-2.7v-8.4h36.8V73zm0-36.8H45.6v-1.5c0-.7.6-1.2 1.2-1.2h34.3c.7 0 1.2.6 1.2 1.2v1.5zm-1.3-5.7H46.9c-2.3 0-4.2 1.9-4.2 4.2v13h-11c-2.5 0-4.5 2-4.5 4.5v10.3H10.8V21.6h78.5v40.8h-3.8V34.7c0-2.3-1.9-4.2-4.3-4.2zm15 38.2c0 .5-.4.9-.9.9h-9.8v-4.1h9.8c.5 0 .9.4.9.9v2.3z" />
        </g>
      </switch>
    </svg>
  )
}
// PROPTYPES
const { string } = PropTypes
Device.propTypes = {
  styling: string,
}

export default Device
